import React from "react";
import { useSelector } from "react-redux";

const BandwidthInvoice = React.forwardRef(({ invoieData }, ref) => {
  const data = invoieData?.[0];

  const packages = useSelector((state) => state?.reseller?.bandwidthPackage);
  const resellers = useSelector((state) => state?.reseller?.bandwidthReseller);

  if (!data) return null;

  const getPackageName = (id) =>
    packages?.find((p) => p?._id === id)?.name || "N/A";

  const getResellerName = (id) =>
    resellers?.find((r) => r?._id === id)?.name || "N/A";

  const styles = {
    page: {
      maxWidth: "900px",
      margin: "0 auto",
      padding: "40px",
      paddingBottom: "80px",
      minHeight: "100vh",
      backgroundColor: "#fff",
      fontFamily: "Arial, sans-serif",
      color: "#333",
      boxSizing: "border-box",
    },

    header: {
      display: "flex",
      justifyContent: "space-between",
      borderBottom: "1px solid #ddd",
      paddingBottom: "20px",
    },

    logo: {
      fontSize: "22px",
      fontWeight: "bold",
    },

    smallText: {
      fontSize: "13px",
      color: "#666",
    },

    infoBox: {
      marginTop: "30px",
      padding: "20px",
      display: "flex",
      justifyContent: "space-between",
      // border: "1px solid #ddd",
      backgroundColor: "#F1F0F0",
    },

    sectionTitle: {
      fontWeight: "bold",
      marginBottom: "6px",
    },

    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "30px",
      backgroundColor: "#fff",
    },

    th: {
      padding: "10px",
      borderBottom: "2px solid #000",
      textAlign: "left",
      backgroundColor: "#fff",
    },

    td: {
      padding: "10px",
      borderBottom: "1px solid #ddd",
      backgroundColor: "#fff",
    },

    summaryWrapper: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "30px",
      backgroundColor: "#fff",
    },

    summary: {
      width: "300px",
    },

    summaryRow: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "8px",
    },

    summaryBold: {
      borderTop: "1px solid #000",
      paddingTop: "10px",
      fontWeight: "bold",
    },

    footer: {
      marginTop: "60px",
      display: "flex",
      justifyContent: "space-between",
      fontSize: "13px",
      backgroundColor: "#fff",
    },

    paid: {
      color: "white",
      fontWeight: "500",
      backgroundColor: "#14FA04",
      padding: "1px 5px",
      borderRadius: "5px",
    },
    unpaid: {
      color: "white",
      fontWeight: "500",
      backgroundColor: "#EC5D71",
      padding: "1px 5px",
      borderRadius: "5px",
    },
  };

  return (
    <div ref={ref} style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <div>
          <div style={styles.logo}>
            <span style={{ color: "#2563eb" }}>NET</span>FEE
          </div>
          <div style={styles.smallText}>Bandwidth Service Provider</div>
        </div>

        <div style={{ textAlign: "right" }}>
          <h1 style={{ margin: 0 }}>INVOICE</h1>
          <div style={styles.smallText}>
            Date: {new Date(data.createdAt).toLocaleDateString()}
          </div>
        </div>
      </div>

      {/* Info */}
      <div style={styles.infoBox}>
        <div>
          <div style={styles.sectionTitle}>Invoice To</div>
          {getResellerName(data.reseller)}
        </div>

        <div>
          <div style={styles.sectionTitle}>Invoice Info</div>
          <div>ID: {data._id}</div>
          <div>Month: {data.month}</div>
          <div>
            Status:{" "}
            <span
              style={
                data.paymentStatus === "paid" ? styles.paid : styles.unpaid
              }
            >
              {data.paymentStatus.toUpperCase()}
            </span>
          </div>
        </div>
      </div>

      {/* Table */}
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Package</th>
            <th style={styles.th}>Period</th>
            <th style={styles.th}>Rate</th>
            <th style={styles.th}>Qty</th>
            <th style={styles.th}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.bandwidth.map((item, i) => (
            <tr key={i}>
              <td style={styles.td}>{getPackageName(item.package)}</td>
              <td style={styles.td}>
                {new Date(item.startDate).toLocaleDateString()} –{" "}
                {new Date(item.endDate).toLocaleDateString()}
              </td>
              <td style={styles.td}>{item.price} ৳</td>
              <td style={styles.td}>{item.quantity}</td>
              <td style={styles.td}>{item.total} ৳</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Summary */}
      <div style={styles.summaryWrapper}>
        <div style={styles.summary}>
          <div style={styles.summaryRow}>
            <span>Previous Due</span>
            <span>{data.previousDue} ৳</span>
          </div>
          <div style={styles.summaryRow}>
            <span>Total Amount</span>
            <span>{data.totalAmount} ৳</span>
          </div>
          <div style={styles.summaryRow}>
            <span>Due Amount</span>
            <span>{data.dueAmount} ৳</span>
          </div>
          <div style={{ ...styles.summaryRow, ...styles.summaryBold }}>
            <span>Grand Total</span>
            <span>{data.grandTotal} ৳</span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <div>
          <b>Payment Info</b>
          <div>Account: Netfee Ltd.</div>
          <div>Method: Cash / Bank</div>
        </div>

        <div style={{ textAlign: "right" }}>
          <b>Authorized Signature</b>
          <div style={{ marginTop: "20px" }}>____________________</div>
        </div>
      </div>
    </div>
  );
});

export default BandwidthInvoice;
